import axios from './index';

/**
 * APIs（仅保留 OpenAPI 支持的：GET /v1/roles 用于账号表单角色下拉）
 */
export const getRoles = () => {
    return axios<ResType<RoleOption[]>>('/v1/roles', {
        method: 'get',
    });
};

export const AccManagementApiErrorCodeMsg: Record<number, string> = {};

/**
 * Types
 */
import type { ResType } from '@/typings/common';

export type RoleOption = {
    id: string;
    name: string;
    permissions?: string[];
    status?: string;
};
